import { type Country, Convert } from './CountryConverter';

export function getCountryById(id: number): Country | undefined {
  return Countries.find(country => country.COU_ID === id);
}

export function getCountryByVorwahl(vorwahl: string): Country | undefined {
	return Countries.find(country => country.COU_VORWAHL === vorwahl);
}

const Countries: Country[] = Convert.toCountry(`[
		{
			"COU_ID": 3,
			"COU_NAME": "Afghanistan",
			"COU_KFZ": "AFG",
			"COU_ISO3166_3": "AFG",
			"COU_VORWAHL": "+93",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "AF"
		},
		{
			"COU_ID": 6,
			"COU_NAME": "Ägypten",
			"COU_KFZ": "ET",
			"COU_ISO3166_3": "EGY",
			"COU_VORWAHL": "+20",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "EG"
		},
		{
			"COU_ID": 9,
			"COU_NAME": "Aland",
			"COU_KFZ": "AX",
			"COU_ISO3166_3": "ALA",
			"COU_VORWAHL": "+358",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "AX"
		},
		{
			"COU_ID": 12,
			"COU_NAME": "Albanien",
			"COU_KFZ": "AL",
			"COU_ISO3166_3": "ALB",
			"COU_VORWAHL": "+355",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "AL"
		},
		{
			"COU_ID": 15,
			"COU_NAME": "Algerien",
			"COU_KFZ": "DZ",
			"COU_ISO3166_3": "DZA",
			"COU_VORWAHL": "+213",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "DZ"
		},
		{
			"COU_ID": 18,
			"COU_NAME": "Amerikanisch Samoa",
			"COU_KFZ": null,
			"COU_ISO3166_3": null,
			"COU_VORWAHL": "+1684",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "AS"
		},
		{
			"COU_ID": 21,
			"COU_NAME": "Andorra",
			"COU_KFZ": "AND",
			"COU_ISO3166_3": "AND",
			"COU_VORWAHL": "+376",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "AD"
		},
		{
			"COU_ID": 24,
			"COU_NAME": "Angola",
			"COU_KFZ": "ANG",
			"COU_ISO3166_3": "AGO",
			"COU_VORWAHL": "+244",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "AO"
		},
		{
			"COU_ID": 27,
			"COU_NAME": "Anguilla",
			"COU_KFZ": "AXA",
			"COU_ISO3166_3": null,
			"COU_VORWAHL": "+1264",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "AI"
		},
		{
			"COU_ID": 30,
			"COU_NAME": "Antarktis",
			"COU_KFZ": null,
			"COU_ISO3166_3": null,
			"COU_VORWAHL": "+6729",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "AQ"
		},
		{
			"COU_ID": 33,
			"COU_NAME": "Antigua und Barbuda",
			"COU_KFZ": "AG",
			"COU_ISO3166_3": "ATG",
			"COU_VORWAHL": "+1809",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "AG"
		},
		{
			"COU_ID": 36,
			"COU_NAME": "Äquartorialguinea",
			"COU_KFZ": "GQ",
			"COU_ISO3166_3": "GNQ",
			"COU_VORWAHL": "+240",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "GQ"
		},
		{
			"COU_ID": 39,
			"COU_NAME": "Argentinien",
			"COU_KFZ": "RA",
			"COU_ISO3166_3": "ARG",
			"COU_VORWAHL": "+54",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "AR"
		},
		{
			"COU_ID": 42,
			"COU_NAME": "Armenien",
			"COU_KFZ": "AR",
			"COU_ISO3166_3": "ARM",
			"COU_VORWAHL": "+374",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "AM"
		},
		{
			"COU_ID": 45,
			"COU_NAME": "Aruba",
			"COU_KFZ": null,
			"COU_ISO3166_3": null,
			"COU_VORWAHL": "+297",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "AW"
		},
		{
			"COU_ID": 48,
			"COU_NAME": "Aserbeidschan",
			"COU_KFZ": "AZ",
			"COU_ISO3166_3": "AZE",
			"COU_VORWAHL": "+994",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "AZ"
		},
		{
			"COU_ID": 51,
			"COU_NAME": "Äthiopien",
			"COU_KFZ": "ETH",
			"COU_ISO3166_3": "ETH",
			"COU_VORWAHL": "+251",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "ET"
		},
		{
			"COU_ID": 54,
			"COU_NAME": "Australien",
			"COU_KFZ": "AUS",
			"COU_ISO3166_3": "AUS",
			"COU_VORWAHL": "+61",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "AU"
		},
		{
			"COU_ID": 57,
			"COU_NAME": "Bahamas",
			"COU_KFZ": "BS",
			"COU_ISO3166_3": "BHS",
			"COU_VORWAHL": "+1809",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "BS"
		},
		{
			"COU_ID": 60,
			"COU_NAME": "Bahrein",
			"COU_KFZ": "BRN",
			"COU_ISO3166_3": "BHR",
			"COU_VORWAHL": "+973",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "BH"
		},
		{
			"COU_ID": 63,
			"COU_NAME": "Bangladesch",
			"COU_KFZ": "BD",
			"COU_ISO3166_3": "BGD",
			"COU_VORWAHL": "+880",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "BD"
		},
		{
			"COU_ID": 66,
			"COU_NAME": "Barbados",
			"COU_KFZ": "BDS",
			"COU_ISO3166_3": "BRB",
			"COU_VORWAHL": "+1809",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "BB"
		},
		{
			"COU_ID": 69,
			"COU_NAME": "Belarus",
			"COU_KFZ": "BY",
			"COU_ISO3166_3": "BLR",
			"COU_VORWAHL": "+375",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "BY"
		},
		{
			"COU_ID": 72,
			"COU_NAME": "Belgien",
			"COU_KFZ": "B",
			"COU_ISO3166_3": "BEL",
			"COU_VORWAHL": "+32",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "BE"
		},
		{
			"COU_ID": 75,
			"COU_NAME": "Belize",
			"COU_KFZ": "BH",
			"COU_ISO3166_3": "BLZ",
			"COU_VORWAHL": "+501",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "BZ"
		},
		{
			"COU_ID": 78,
			"COU_NAME": "Benin",
			"COU_KFZ": "DY",
			"COU_ISO3166_3": "BEN",
			"COU_VORWAHL": "+229",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "BJ"
		},
		{
			"COU_ID": 81,
			"COU_NAME": "Bermuda",
			"COU_KFZ": null,
			"COU_ISO3166_3": null,
			"COU_VORWAHL": "+1441",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "BM"
		},
		{
			"COU_ID": 84,
			"COU_NAME": "Bhutan",
			"COU_KFZ": "BHT",
			"COU_ISO3166_3": "BTN",
			"COU_VORWAHL": "+975",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "BT"
		},
		{
			"COU_ID": 87,
			"COU_NAME": "Bolivien",
			"COU_KFZ": "BOL",
			"COU_ISO3166_3": "BOL",
			"COU_VORWAHL": "+591",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "BO"
		},
		{
			"COU_ID": 90,
			"COU_NAME": "Bosnien und Herzegowina",
			"COU_KFZ": "BIH",
			"COU_ISO3166_3": "BIH",
			"COU_VORWAHL": "+387",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "BA"
		},
		{
			"COU_ID": 93,
			"COU_NAME": "Botsuana",
			"COU_KFZ": "RB",
			"COU_ISO3166_3": "BWA",
			"COU_VORWAHL": "d",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "BW"
		},
		{
			"COU_ID": 96,
			"COU_NAME": "Bouvetinsel",
			"COU_KFZ": null,
			"COU_ISO3166_3": null,
			"COU_VORWAHL": "+47",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "BV"
		},
		{
			"COU_ID": 99,
			"COU_NAME": "Brasilien",
			"COU_KFZ": "BR",
			"COU_ISO3166_3": "BRA",
			"COU_VORWAHL": "+55",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "BR"
		},
		{
			"COU_ID": 102,
			"COU_NAME": "Brunei",
			"COU_KFZ": "BRU",
			"COU_ISO3166_3": "BRN",
			"COU_VORWAHL": "+673",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "BN"
		},
		{
			"COU_ID": 105,
			"COU_NAME": "Bulgarien",
			"COU_KFZ": "BG",
			"COU_ISO3166_3": "BGR",
			"COU_VORWAHL": "+359",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "BG"
		},
		{
			"COU_ID": 108,
			"COU_NAME": "Burkina Faso",
			"COU_KFZ": "BF",
			"COU_ISO3166_3": "BFA",
			"COU_VORWAHL": "+226",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "BF"
		},
		{
			"COU_ID": 111,
			"COU_NAME": "Burundi",
			"COU_KFZ": "RU",
			"COU_ISO3166_3": "BDI",
			"COU_VORWAHL": "+257",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "BI"
		},
		{
			"COU_ID": 114,
			"COU_NAME": "Chile",
			"COU_KFZ": "RCH",
			"COU_ISO3166_3": "CHL",
			"COU_VORWAHL": "+56",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "CL"
		},
		{
			"COU_ID": 117,
			"COU_NAME": "China",
			"COU_KFZ": "VR",
			"COU_ISO3166_3": "CHN",
			"COU_VORWAHL": "+86",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "CN"
		},
		{
			"COU_ID": 120,
			"COU_NAME": "Cookinseln",
			"COU_KFZ": "NZ",
			"COU_ISO3166_3": null,
			"COU_VORWAHL": "+682",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "CK"
		},
		{
			"COU_ID": 123,
			"COU_NAME": "Costa Rica",
			"COU_KFZ": "CR",
			"COU_ISO3166_3": "CRI",
			"COU_VORWAHL": "+506",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "CR"
		},
		{
			"COU_ID": 126,
			"COU_NAME": "Cote d'Ivoire",
			"COU_KFZ": "CI",
			"COU_ISO3166_3": "CIV",
			"COU_VORWAHL": "+225",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "CI"
		},
		{
			"COU_ID": 129,
			"COU_NAME": "Dänemark",
			"COU_KFZ": "DK",
			"COU_ISO3166_3": "DNK",
			"COU_VORWAHL": "+45",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "DK"
		},
		{
			"COU_ID": 132,
			"COU_NAME": "Dem. Volksrepublik Korea",
			"COU_KFZ": "KP",
			"COU_ISO3166_3": "PRK",
			"COU_VORWAHL": "+850",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "KP"
		},
		{
			"COU_ID": 135,
			"COU_NAME": "Demokratische Republik Kongo",
			"COU_KFZ": "CD",
			"COU_ISO3166_3": "COD",
			"COU_VORWAHL": "+243",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "CD"
		},
		{
			"COU_ID": 138,
			"COU_NAME": "Deutschland",
			"COU_KFZ": "D",
			"COU_ISO3166_3": "DEU",
			"COU_VORWAHL": "+49",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "DE"
		},
		{
			"COU_ID": 141,
			"COU_NAME": "Dominica",
			"COU_KFZ": "WD",
			"COU_ISO3166_3": "DMA",
			"COU_VORWAHL": "+1809",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "DM"
		},
		{
			"COU_ID": 144,
			"COU_NAME": "Dominikanische Republik",
			"COU_KFZ": "DOM",
			"COU_ISO3166_3": "DOM",
			"COU_VORWAHL": "+1809",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "DO"
		},
		{
			"COU_ID": 147,
			"COU_NAME": "Dschibuti",
			"COU_KFZ": "DJI",
			"COU_ISO3166_3": "DJI",
			"COU_VORWAHL": "+253",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "DJ"
		},
		{
			"COU_ID": 150,
			"COU_NAME": "Ecuador",
			"COU_KFZ": "EC",
			"COU_ISO3166_3": "ECU",
			"COU_VORWAHL": "+593",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "EC"
		},
		{
			"COU_ID": 153,
			"COU_NAME": "El Salvador",
			"COU_KFZ": "ES",
			"COU_ISO3166_3": "SLV",
			"COU_VORWAHL": "+503",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "SV"
		},
		{
			"COU_ID": 156,
			"COU_NAME": "Eritrea",
			"COU_KFZ": "ER",
			"COU_ISO3166_3": "ERI",
			"COU_VORWAHL": "+291",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "ER"
		},
		{
			"COU_ID": 159,
			"COU_NAME": "Estland",
			"COU_KFZ": "EST",
			"COU_ISO3166_3": "EST",
			"COU_VORWAHL": "+372",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "EE"
		},
		{
			"COU_ID": 162,
			"COU_NAME": "Falklandinseln",
			"COU_KFZ": null,
			"COU_ISO3166_3": null,
			"COU_VORWAHL": "+500",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "FK"
		},
		{
			"COU_ID": 165,
			"COU_NAME": "Faröer",
			"COU_KFZ": "FR",
			"COU_ISO3166_3": "FRO",
			"COU_VORWAHL": "+298",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "FO"
		},
		{
			"COU_ID": 168,
			"COU_NAME": "Fidschi",
			"COU_KFZ": "FJI",
			"COU_ISO3166_3": "FJI",
			"COU_VORWAHL": "+679",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "FJ"
		},
		{
			"COU_ID": 171,
			"COU_NAME": "Finnland",
			"COU_KFZ": "FIN",
			"COU_ISO3166_3": "FIN",
			"COU_VORWAHL": "+358",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "FI"
		},
		{
			"COU_ID": 174,
			"COU_NAME": "Frankreich",
			"COU_KFZ": "F",
			"COU_ISO3166_3": "FRA",
			"COU_VORWAHL": "+33",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "FR"
		},
		{
			"COU_ID": 177,
			"COU_NAME": "Gabun",
			"COU_KFZ": "G",
			"COU_ISO3166_3": "GAB",
			"COU_VORWAHL": "+241",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "GA"
		},
		{
			"COU_ID": 180,
			"COU_NAME": "Gambia",
			"COU_KFZ": "WAG",
			"COU_ISO3166_3": "GMB",
			"COU_VORWAHL": "+220",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "GM"
		},
		{
			"COU_ID": 183,
			"COU_NAME": "Georgien",
			"COU_KFZ": "GE",
			"COU_ISO3166_3": "GEO",
			"COU_VORWAHL": "+995",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "GE"
		},
		{
			"COU_ID": 186,
			"COU_NAME": "Ghana",
			"COU_KFZ": "GH",
			"COU_ISO3166_3": "GHA",
			"COU_VORWAHL": "+233",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "GH"
		},
		{
			"COU_ID": 189,
			"COU_NAME": "Gibraltar",
			"COU_KFZ": "GBZ",
			"COU_ISO3166_3": "GIB",
			"COU_VORWAHL": "+350",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "GI"
		},
		{
			"COU_ID": 192,
			"COU_NAME": "Grenada",
			"COU_KFZ": "WG",
			"COU_ISO3166_3": "GRD",
			"COU_VORWAHL": "+1809",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "GD"
		},
		{
			"COU_ID": 195,
			"COU_NAME": "Griechenland",
			"COU_KFZ": "GR",
			"COU_ISO3166_3": "GRC",
			"COU_VORWAHL": "+30",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "GR"
		},
		{
			"COU_ID": 198,
			"COU_NAME": "Grönland",
			"COU_KFZ": "GL",
			"COU_ISO3166_3": null,
			"COU_VORWAHL": "+299",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "GL"
		},
		{
			"COU_ID": 201,
			"COU_NAME": "Großbritannien",
			"COU_KFZ": "GB",
			"COU_ISO3166_3": "GBR",
			"COU_VORWAHL": "+44",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "GB"
		},
		{
			"COU_ID": 204,
			"COU_NAME": "Guam",
			"COU_KFZ": null,
			"COU_ISO3166_3": null,
			"COU_VORWAHL": "+1671",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "GU"
		},
		{
			"COU_ID": 207,
			"COU_NAME": "Guatemala",
			"COU_KFZ": "GCA",
			"COU_ISO3166_3": "GTM",
			"COU_VORWAHL": "+502",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "GT"
		},
		{
			"COU_ID": 210,
			"COU_NAME": "Guinea",
			"COU_KFZ": "RG",
			"COU_ISO3166_3": "GIN",
			"COU_VORWAHL": "+224",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "GN"
		},
		{
			"COU_ID": 213,
			"COU_NAME": "Guinea-Bissau",
			"COU_KFZ": "GUB",
			"COU_ISO3166_3": "GNB",
			"COU_VORWAHL": "+245",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "GW"
		},
		{
			"COU_ID": 216,
			"COU_NAME": "Guyana",
			"COU_KFZ": "GUY",
			"COU_ISO3166_3": "GUY",
			"COU_VORWAHL": "+592",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "GY"
		},
		{
			"COU_ID": 219,
			"COU_NAME": "Haiti",
			"COU_KFZ": "RH",
			"COU_ISO3166_3": "HTI",
			"COU_VORWAHL": "+509",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "HT"
		},
		{
			"COU_ID": 222,
			"COU_NAME": "Honduras",
			"COU_KFZ": "HN",
			"COU_ISO3166_3": "HND",
			"COU_VORWAHL": "+504",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "HN"
		},
		{
			"COU_ID": 225,
			"COU_NAME": "Hongkong",
			"COU_KFZ": "HK",
			"COU_ISO3166_3": "HKG",
			"COU_VORWAHL": "+852",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "HK"
		},
		{
			"COU_ID": 228,
			"COU_NAME": "Indien",
			"COU_KFZ": "IND",
			"COU_ISO3166_3": "IND",
			"COU_VORWAHL": "+91",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "IN"
		},
		{
			"COU_ID": 231,
			"COU_NAME": "Indonesien",
			"COU_KFZ": "RI",
			"COU_ISO3166_3": "IDN",
			"COU_VORWAHL": "+62",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "ID"
		},
		{
			"COU_ID": 234,
			"COU_NAME": "Irak",
			"COU_KFZ": "IRQ",
			"COU_ISO3166_3": "IRQ",
			"COU_VORWAHL": "+964",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "IQ"
		},
		{
			"COU_ID": 237,
			"COU_NAME": "Iran",
			"COU_KFZ": "IR",
			"COU_ISO3166_3": "IRN",
			"COU_VORWAHL": "+98",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "IR"
		},
		{
			"COU_ID": 240,
			"COU_NAME": "Irland",
			"COU_KFZ": "IRL",
			"COU_ISO3166_3": "IRL",
			"COU_VORWAHL": "+353",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "IE"
		},
		{
			"COU_ID": 243,
			"COU_NAME": "Island",
			"COU_KFZ": "IS",
			"COU_ISO3166_3": "ISL",
			"COU_VORWAHL": "+354",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "IS"
		},
		{
			"COU_ID": 246,
			"COU_NAME": "Israel",
			"COU_KFZ": "IL",
			"COU_ISO3166_3": "ISR",
			"COU_VORWAHL": "+972",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "IL"
		},
		{
			"COU_ID": 249,
			"COU_NAME": "Italien",
			"COU_KFZ": "I",
			"COU_ISO3166_3": "ITA",
			"COU_VORWAHL": "+39",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "IT"
		},
		{
			"COU_ID": 252,
			"COU_NAME": "Jamaika",
			"COU_KFZ": "JA",
			"COU_ISO3166_3": "JAM",
			"COU_VORWAHL": "+1876",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "JM"
		},
		{
			"COU_ID": 255,
			"COU_NAME": "Japan",
			"COU_KFZ": "J",
			"COU_ISO3166_3": "JPN",
			"COU_VORWAHL": "+81",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "JP"
		},
		{
			"COU_ID": 258,
			"COU_NAME": "Jemen",
			"COU_KFZ": "ADN",
			"COU_ISO3166_3": "YEM",
			"COU_VORWAHL": "+967",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "YE"
		},
		{
			"COU_ID": 261,
			"COU_NAME": "Jordanien",
			"COU_KFZ": "JOR",
			"COU_ISO3166_3": "JOR",
			"COU_VORWAHL": "+962",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "JO"
		},
		{
			"COU_ID": 264,
			"COU_NAME": "Kambodscha",
			"COU_KFZ": "K",
			"COU_ISO3166_3": "KHM",
			"COU_VORWAHL": "+855",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "KH"
		},
		{
			"COU_ID": 267,
			"COU_NAME": "Kamerun",
			"COU_KFZ": "CAM",
			"COU_ISO3166_3": "CMR",
			"COU_VORWAHL": "+237",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "CM"
		},
		{
			"COU_ID": 270,
			"COU_NAME": "Kanada",
			"COU_KFZ": "CDN",
			"COU_ISO3166_3": "CAN",
			"COU_VORWAHL": "+1",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "CA"
		},
		{
			"COU_ID": 273,
			"COU_NAME": "Kap Verde",
			"COU_KFZ": "CV",
			"COU_ISO3166_3": "CPV",
			"COU_VORWAHL": "+238",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "CV"
		},
		{
			"COU_ID": 276,
			"COU_NAME": "Kasachstan",
			"COU_KFZ": "KZ",
			"COU_ISO3166_3": "KAZ",
			"COU_VORWAHL": "+7",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "KZ"
		},
		{
			"COU_ID": 279,
			"COU_NAME": "Katar",
			"COU_KFZ": "Q",
			"COU_ISO3166_3": "QAT",
			"COU_VORWAHL": "+974",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "QA"
		},
		{
			"COU_ID": 282,
			"COU_NAME": "Kenia",
			"COU_KFZ": "EAK",
			"COU_ISO3166_3": "KEN",
			"COU_VORWAHL": "+254",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "KE"
		},
		{
			"COU_ID": 285,
			"COU_NAME": "Kirgisistan",
			"COU_KFZ": "KS",
			"COU_ISO3166_3": "KGZ",
			"COU_VORWAHL": "+996",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "KG"
		},
		{
			"COU_ID": 288,
			"COU_NAME": "Kiribati",
			"COU_KFZ": "KIR",
			"COU_ISO3166_3": "KIR",
			"COU_VORWAHL": "+686",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "KI"
		},
		{
			"COU_ID": 291,
			"COU_NAME": "Kokosinseln",
			"COU_KFZ": null,
			"COU_ISO3166_3": null,
			"COU_VORWAHL": "+61891",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "CC"
		},
		{
			"COU_ID": 294,
			"COU_NAME": "Kolumbien",
			"COU_KFZ": "CO",
			"COU_ISO3166_3": "COL",
			"COU_VORWAHL": "+57",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "CO"
		},
		{
			"COU_ID": 297,
			"COU_NAME": "Komoren",
			"COU_KFZ": "COM",
			"COU_ISO3166_3": "COM",
			"COU_VORWAHL": "+269",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "KM"
		},
		{
			"COU_ID": 300,
			"COU_NAME": "Kosovo",
			"COU_KFZ": null,
			"COU_ISO3166_3": null,
			"COU_VORWAHL": "+381",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "XK"
		},
		{
			"COU_ID": 303,
			"COU_NAME": "Kroatien",
			"COU_KFZ": "HR",
			"COU_ISO3166_3": "HRV",
			"COU_VORWAHL": "+385",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "HR"
		},
		{
			"COU_ID": 306,
			"COU_NAME": "Kuba",
			"COU_KFZ": "C",
			"COU_ISO3166_3": "CUB",
			"COU_VORWAHL": "+53",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "CU"
		},
		{
			"COU_ID": 309,
			"COU_NAME": "Kuwait",
			"COU_KFZ": "KWT",
			"COU_ISO3166_3": "KWT",
			"COU_VORWAHL": "+965",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "KW"
		},
		{
			"COU_ID": 312,
			"COU_NAME": "Laotische Dem. Volksrep.",
			"COU_KFZ": "LAO",
			"COU_ISO3166_3": "LAO",
			"COU_VORWAHL": "+856",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "LA"
		},
		{
			"COU_ID": 315,
			"COU_NAME": "Lesotho",
			"COU_KFZ": "LS",
			"COU_ISO3166_3": "LSO",
			"COU_VORWAHL": "+266",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "LS"
		},
		{
			"COU_ID": 318,
			"COU_NAME": "Lettland",
			"COU_KFZ": "LV",
			"COU_ISO3166_3": "LVA",
			"COU_VORWAHL": "+371",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "LV"
		},
		{
			"COU_ID": 321,
			"COU_NAME": "Libanon",
			"COU_KFZ": "RL",
			"COU_ISO3166_3": "LBN",
			"COU_VORWAHL": "+961",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "LB"
		},
		{
			"COU_ID": 324,
			"COU_NAME": "Liberia",
			"COU_KFZ": "LB",
			"COU_ISO3166_3": "LBR",
			"COU_VORWAHL": "+231",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "LR"
		},
		{
			"COU_ID": 327,
			"COU_NAME": "Libysch-Arabische Dschamahirija (Volksrepublik)",
			"COU_KFZ": "LAR",
			"COU_ISO3166_3": "LBY",
			"COU_VORWAHL": "+218",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "LY"
		},
		{
			"COU_ID": 330,
			"COU_NAME": "Liechtenstein",
			"COU_KFZ": "FL",
			"COU_ISO3166_3": "LIE",
			"COU_VORWAHL": "+423",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "LI"
		},
		{
			"COU_ID": 333,
			"COU_NAME": "Litauen",
			"COU_KFZ": "LT",
			"COU_ISO3166_3": "LTU",
			"COU_VORWAHL": "+370",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "LT"
		},
		{
			"COU_ID": 336,
			"COU_NAME": "Luxemburg",
			"COU_KFZ": "L",
			"COU_ISO3166_3": "LUX",
			"COU_VORWAHL": "+352",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "LU"
		},
		{
			"COU_ID": 339,
			"COU_NAME": "Macao",
			"COU_KFZ": "-",
			"COU_ISO3166_3": "MAC",
			"COU_VORWAHL": "+853",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MO"
		},
		{
			"COU_ID": 342,
			"COU_NAME": "Madagaskar",
			"COU_KFZ": "RM",
			"COU_ISO3166_3": "MDG",
			"COU_VORWAHL": "+261",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MG"
		},
		{
			"COU_ID": 345,
			"COU_NAME": "Malawi",
			"COU_KFZ": "MW",
			"COU_ISO3166_3": "MWI",
			"COU_VORWAHL": "+265",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MW"
		},
		{
			"COU_ID": 348,
			"COU_NAME": "Malaysia",
			"COU_KFZ": "MAL",
			"COU_ISO3166_3": "MYS",
			"COU_VORWAHL": "+60",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MY"
		},
		{
			"COU_ID": 351,
			"COU_NAME": "Malediven",
			"COU_KFZ": "MV",
			"COU_ISO3166_3": "MDV",
			"COU_VORWAHL": "+960",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MV"
		},
		{
			"COU_ID": 354,
			"COU_NAME": "Mali",
			"COU_KFZ": "RMM",
			"COU_ISO3166_3": "MLI",
			"COU_VORWAHL": "+223",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "ML"
		},
		{
			"COU_ID": 357,
			"COU_NAME": "Malta",
			"COU_KFZ": "M",
			"COU_ISO3166_3": "MLT",
			"COU_VORWAHL": "+356",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "MT"
		},
		{
			"COU_ID": 360,
			"COU_NAME": "Marokko",
			"COU_KFZ": "MA",
			"COU_ISO3166_3": "MAR",
			"COU_VORWAHL": "+212",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MA"
		},
		{
			"COU_ID": 363,
			"COU_NAME": "Marshallinseln",
			"COU_KFZ": "MH",
			"COU_ISO3166_3": "MHL",
			"COU_VORWAHL": "+692",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MH"
		},
		{
			"COU_ID": 366,
			"COU_NAME": "Mauretanien",
			"COU_KFZ": "RIM",
			"COU_ISO3166_3": "MRT",
			"COU_VORWAHL": "+222",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MR"
		},
		{
			"COU_ID": 369,
			"COU_NAME": "Mauritius",
			"COU_KFZ": "MS",
			"COU_ISO3166_3": "MUS",
			"COU_VORWAHL": "+230",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MU"
		},
		{
			"COU_ID": 372,
			"COU_NAME": "Mazedonien",
			"COU_KFZ": "MK",
			"COU_ISO3166_3": "MKD",
			"COU_VORWAHL": "+389",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MK"
		},
		{
			"COU_ID": 375,
			"COU_NAME": "Mexiko",
			"COU_KFZ": "MEX",
			"COU_ISO3166_3": "MEX",
			"COU_VORWAHL": "+52",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MX"
		},
		{
			"COU_ID": 378,
			"COU_NAME": "Mikronesien",
			"COU_KFZ": "FSM",
			"COU_ISO3166_3": "FSM",
			"COU_VORWAHL": "+691",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "FM"
		},
		{
			"COU_ID": 381,
			"COU_NAME": "Moldau",
			"COU_KFZ": "MD",
			"COU_ISO3166_3": "MDA",
			"COU_VORWAHL": "+373",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MD"
		},
		{
			"COU_ID": 384,
			"COU_NAME": "Monaco",
			"COU_KFZ": "MC",
			"COU_ISO3166_3": "MCO",
			"COU_VORWAHL": "+377",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MC"
		},
		{
			"COU_ID": 387,
			"COU_NAME": "Mongolei",
			"COU_KFZ": "MGL",
			"COU_ISO3166_3": "MNG",
			"COU_VORWAHL": "+976",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MN"
		},
		{
			"COU_ID": 390,
			"COU_NAME": "Montenegro",
			"COU_KFZ": "MNE",
			"COU_ISO3166_3": "MNE",
			"COU_VORWAHL": "+382",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "ME"
		},
		{
			"COU_ID": 393,
			"COU_NAME": "Montserrat",
			"COU_KFZ": null,
			"COU_ISO3166_3": null,
			"COU_VORWAHL": "+1664",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MS"
		},
		{
			"COU_ID": 396,
			"COU_NAME": "Mosambik",
			"COU_KFZ": "MOC",
			"COU_ISO3166_3": "MOZ",
			"COU_VORWAHL": "+258",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MZ"
		},
		{
			"COU_ID": 399,
			"COU_NAME": "Myanmar",
			"COU_KFZ": "MYA",
			"COU_ISO3166_3": "MMR",
			"COU_VORWAHL": "+95",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MM"
		},
		{
			"COU_ID": 402,
			"COU_NAME": "Namibia",
			"COU_KFZ": "NAM",
			"COU_ISO3166_3": "NAM",
			"COU_VORWAHL": "+264",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "NA"
		},
		{
			"COU_ID": 405,
			"COU_NAME": "Nauru",
			"COU_KFZ": "NAU",
			"COU_ISO3166_3": "NRU",
			"COU_VORWAHL": "+674",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "NR"
		},
		{
			"COU_ID": 408,
			"COU_NAME": "Nepal",
			"COU_KFZ": "NEP",
			"COU_ISO3166_3": "NPL",
			"COU_VORWAHL": "+977",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "NP"
		},
		{
			"COU_ID": 411,
			"COU_NAME": "Neuseeland",
			"COU_KFZ": "NZ",
			"COU_ISO3166_3": "NZL",
			"COU_VORWAHL": "+64",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "NZ"
		},
		{
			"COU_ID": 414,
			"COU_NAME": "Nicaragua",
			"COU_KFZ": "NIC",
			"COU_ISO3166_3": "NIC",
			"COU_VORWAHL": "+505",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "NI"
		},
		{
			"COU_ID": 417,
			"COU_NAME": "Niederlande",
			"COU_KFZ": "NL",
			"COU_ISO3166_3": "NLD",
			"COU_VORWAHL": "+31",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "NL"
		},
		{
			"COU_ID": 420,
			"COU_NAME": "Niederländische Antillen",
			"COU_KFZ": "NA",
			"COU_ISO3166_3": null,
			"COU_VORWAHL": "+599",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "AN"
		},
		{
			"COU_ID": 423,
			"COU_NAME": "Niger",
			"COU_KFZ": "RN",
			"COU_ISO3166_3": "NER",
			"COU_VORWAHL": "+227",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "NE"
		},
		{
			"COU_ID": 426,
			"COU_NAME": "Nigeria",
			"COU_KFZ": "WAN",
			"COU_ISO3166_3": "NGA",
			"COU_VORWAHL": "+234",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "NG"
		},
		{
			"COU_ID": 429,
			"COU_NAME": "Niue",
			"COU_KFZ": "-",
			"COU_ISO3166_3": "NIU",
			"COU_VORWAHL": "+683",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "NU"
		},
		{
			"COU_ID": 432,
			"COU_NAME": "Nördliche Marianen",
			"COU_KFZ": "-",
			"COU_ISO3166_3": "MNP",
			"COU_VORWAHL": "+670",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "MP"
		},
		{
			"COU_ID": 435,
			"COU_NAME": "Norwegen",
			"COU_KFZ": "N",
			"COU_ISO3166_3": "NOR",
			"COU_VORWAHL": "+47",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "NO"
		},
		{
			"COU_ID": 438,
			"COU_NAME": "Oman",
			"COU_KFZ": "OM",
			"COU_ISO3166_3": "OMN",
			"COU_VORWAHL": "+968",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "OM"
		},
		{
			"COU_ID": 441,
			"COU_NAME": "Österreich",
			"COU_KFZ": "A",
			"COU_ISO3166_3": "AUT",
			"COU_VORWAHL": "+43",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "AT"
		},
		{
			"COU_ID": 444,
			"COU_NAME": "Pakistan",
			"COU_KFZ": "PK",
			"COU_ISO3166_3": "PAK",
			"COU_VORWAHL": "+92",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "PK"
		},
		{
			"COU_ID": 447,
			"COU_NAME": "Palästina",
			"COU_KFZ": "AUT",
			"COU_ISO3166_3": "PSE",
			"COU_VORWAHL": "+970",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "PS"
		},
		{
			"COU_ID": 450,
			"COU_NAME": "Palau",
			"COU_KFZ": "PAL",
			"COU_ISO3166_3": "PLW",
			"COU_VORWAHL": "+680",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "PW"
		},
		{
			"COU_ID": 453,
			"COU_NAME": "Panama",
			"COU_KFZ": "PA",
			"COU_ISO3166_3": "PAN",
			"COU_VORWAHL": "+507",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "PA"
		},
		{
			"COU_ID": 456,
			"COU_NAME": "Papua-Neuguinea",
			"COU_KFZ": "PNG",
			"COU_ISO3166_3": "PNG",
			"COU_VORWAHL": "+675",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "PG"
		},
		{
			"COU_ID": 459,
			"COU_NAME": "Paraguay",
			"COU_KFZ": "PY",
			"COU_ISO3166_3": "PRY",
			"COU_VORWAHL": "+595",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "PY"
		},
		{
			"COU_ID": 462,
			"COU_NAME": "Peru",
			"COU_KFZ": "PE",
			"COU_ISO3166_3": "PER",
			"COU_VORWAHL": "+51",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "PE"
		},
		{
			"COU_ID": 465,
			"COU_NAME": "Philippinen",
			"COU_KFZ": "RP",
			"COU_ISO3166_3": "PHL",
			"COU_VORWAHL": "+63",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "PH"
		},
		{
			"COU_ID": 468,
			"COU_NAME": "Polen",
			"COU_KFZ": "PL",
			"COU_ISO3166_3": "POL",
			"COU_VORWAHL": "+48",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "PL"
		},
		{
			"COU_ID": 471,
			"COU_NAME": "Portugal",
			"COU_KFZ": "P",
			"COU_ISO3166_3": "PRT",
			"COU_VORWAHL": "+351",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "PT"
		},
		{
			"COU_ID": 474,
			"COU_NAME": "Republik Kongo",
			"COU_KFZ": "RCB",
			"COU_ISO3166_3": "COG",
			"COU_VORWAHL": "+242",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "CG"
		},
		{
			"COU_ID": 477,
			"COU_NAME": "Republik Korea",
			"COU_KFZ": "ROK",
			"COU_ISO3166_3": "KOR",
			"COU_VORWAHL": "+82",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "KR"
		},
		{
			"COU_ID": 480,
			"COU_NAME": "Ruanda",
			"COU_KFZ": "RWA",
			"COU_ISO3166_3": "RWA",
			"COU_VORWAHL": "+250",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "RW"
		},
		{
			"COU_ID": 483,
			"COU_NAME": "Rumänien",
			"COU_KFZ": "RO",
			"COU_ISO3166_3": "ROU",
			"COU_VORWAHL": "+40",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "RO"
		},
		{
			"COU_ID": 486,
			"COU_NAME": "Russische Föderation",
			"COU_KFZ": "RUS",
			"COU_ISO3166_3": "RUS",
			"COU_VORWAHL": "+7",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "RU"
		},
		{
			"COU_ID": 489,
			"COU_NAME": "Salomonen",
			"COU_KFZ": "SOL",
			"COU_ISO3166_3": "SLB",
			"COU_VORWAHL": "+677",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "SB"
		},
		{
			"COU_ID": 492,
			"COU_NAME": "Sambia",
			"COU_KFZ": "Z",
			"COU_ISO3166_3": "ZMB",
			"COU_VORWAHL": "+260",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "ZM"
		},
		{
			"COU_ID": 495,
			"COU_NAME": "Samoa",
			"COU_KFZ": "WS",
			"COU_ISO3166_3": "WSM",
			"COU_VORWAHL": "+685",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "WS"
		},
		{
			"COU_ID": 498,
			"COU_NAME": "San Marino",
			"COU_KFZ": "RSM",
			"COU_ISO3166_3": "SMR",
			"COU_VORWAHL": "+378",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "SM"
		},
		{
			"COU_ID": 501,
			"COU_NAME": "Sao Tome und Principe",
			"COU_KFZ": "-",
			"COU_ISO3166_3": "STP",
			"COU_VORWAHL": "+239",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "ST"
		},
		{
			"COU_ID": 504,
			"COU_NAME": "Saudi Arabien",
			"COU_KFZ": "KSA",
			"COU_ISO3166_3": "SAU",
			"COU_VORWAHL": "+966",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "SA"
		},
		{
			"COU_ID": 507,
			"COU_NAME": "Schweden",
			"COU_KFZ": "S",
			"COU_ISO3166_3": "SWE",
			"COU_VORWAHL": "+46",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "SE"
		},
		{
			"COU_ID": 510,
			"COU_NAME": "Schweiz",
			"COU_KFZ": "CH",
			"COU_ISO3166_3": "CHE",
			"COU_VORWAHL": "+41",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "CH"
		},
		{
			"COU_ID": 513,
			"COU_NAME": "Senegal",
			"COU_KFZ": "SN",
			"COU_ISO3166_3": "SEN",
			"COU_VORWAHL": "+221",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "SN"
		},
		{
			"COU_ID": 516,
			"COU_NAME": "Serbien",
			"COU_KFZ": "SRB",
			"COU_ISO3166_3": "SRB",
			"COU_VORWAHL": "+381",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "RS"
		},
		{
			"COU_ID": 519,
			"COU_NAME": "Seychellen",
			"COU_KFZ": "SY",
			"COU_ISO3166_3": "SYC",
			"COU_VORWAHL": "+248",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "SC"
		},
		{
			"COU_ID": 522,
			"COU_NAME": "Sierra Leone",
			"COU_KFZ": "WAL",
			"COU_ISO3166_3": "SLE",
			"COU_VORWAHL": "+232",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "SL"
		},
		{
			"COU_ID": 525,
			"COU_NAME": "Simbabwe",
			"COU_KFZ": "ZW",
			"COU_ISO3166_3": "ZWE",
			"COU_VORWAHL": "+263",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "ZW"
		},
		{
			"COU_ID": 528,
			"COU_NAME": "Singapur",
			"COU_KFZ": "SGP",
			"COU_ISO3166_3": "SGP",
			"COU_VORWAHL": "+65",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "SG"
		},
		{
			"COU_ID": 531,
			"COU_NAME": "Slowakische Republik",
			"COU_KFZ": "SK",
			"COU_ISO3166_3": "SVK",
			"COU_VORWAHL": "+421",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "SK"
		},
		{
			"COU_ID": 534,
			"COU_NAME": "Slowenien",
			"COU_KFZ": "SLO",
			"COU_ISO3166_3": "SVN",
			"COU_VORWAHL": "+386",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "SI"
		},
		{
			"COU_ID": 537,
			"COU_NAME": "Somalia",
			"COU_KFZ": "SP",
			"COU_ISO3166_3": "SOM",
			"COU_VORWAHL": "+252",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "SO"
		},
		{
			"COU_ID": 540,
			"COU_NAME": "Spanien",
			"COU_KFZ": "E",
			"COU_ISO3166_3": "ESP",
			"COU_VORWAHL": "+34",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "ES"
		},
		{
			"COU_ID": 543,
			"COU_NAME": "Sri Lanka",
			"COU_KFZ": "CL",
			"COU_ISO3166_3": "LKA",
			"COU_VORWAHL": "+94",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "LK"
		},
		{
			"COU_ID": 546,
			"COU_NAME": "St.Kitts und Nevis",
			"COU_KFZ": "-",
			"COU_ISO3166_3": "KNA",
			"COU_VORWAHL": "+1869",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "KN"
		},
		{
			"COU_ID": 549,
			"COU_NAME": "St.Lucia",
			"COU_KFZ": "WL",
			"COU_ISO3166_3": "LCA",
			"COU_VORWAHL": "+1758",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "LC"
		},
		{
			"COU_ID": 552,
			"COU_NAME": "St.Vincent",
			"COU_KFZ": "WV",
			"COU_ISO3166_3": "VCT",
			"COU_VORWAHL": "+1784",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "VC"
		},
		{
			"COU_ID": 555,
			"COU_NAME": "Südafrika",
			"COU_KFZ": "ZA",
			"COU_ISO3166_3": "ZAF",
			"COU_VORWAHL": "+27",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "ZA"
		},
		{
			"COU_ID": 558,
			"COU_NAME": "Sudan",
			"COU_KFZ": "SUD",
			"COU_ISO3166_3": "SDN",
			"COU_VORWAHL": "+249",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "SD"
		},
		{
			"COU_ID": 561,
			"COU_NAME": "Suriname",
			"COU_KFZ": "SME",
			"COU_ISO3166_3": "SUR",
			"COU_VORWAHL": "+597",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "SR"
		},
		{
			"COU_ID": 564,
			"COU_NAME": "Swasiland",
			"COU_KFZ": "SD",
			"COU_ISO3166_3": "SWZ",
			"COU_VORWAHL": "+268",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "SZ"
		},
		{
			"COU_ID": 567,
			"COU_NAME": "Syrien",
			"COU_KFZ": "SYR",
			"COU_ISO3166_3": "SYR",
			"COU_VORWAHL": "+963",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "SY"
		},
		{
			"COU_ID": 570,
			"COU_NAME": "Tadschikistan",
			"COU_KFZ": "TJ",
			"COU_ISO3166_3": "TJK",
			"COU_VORWAHL": "+992",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "TJ"
		},
		{
			"COU_ID": 573,
			"COU_NAME": "Taiwan",
			"COU_KFZ": "RC",
			"COU_ISO3166_3": "TWN",
			"COU_VORWAHL": "+886",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "TW"
		},
		{
			"COU_ID": 576,
			"COU_NAME": "Tansania",
			"COU_KFZ": "EAT",
			"COU_ISO3166_3": "TZA",
			"COU_VORWAHL": "+255",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "TZ"
		},
		{
			"COU_ID": 579,
			"COU_NAME": "Thailand",
			"COU_KFZ": "THA",
			"COU_ISO3166_3": "THA",
			"COU_VORWAHL": "r",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "TH"
		},
		{
			"COU_ID": 582,
			"COU_NAME": "Timor-Leste",
			"COU_KFZ": "TL",
			"COU_ISO3166_3": "TL",
			"COU_VORWAHL": "+670",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "TL"
		},
		{
			"COU_ID": 585,
			"COU_NAME": "Togo",
			"COU_KFZ": "RT",
			"COU_ISO3166_3": "TGO",
			"COU_VORWAHL": "+228",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "TG"
		},
		{
			"COU_ID": 588,
			"COU_NAME": "Tonga",
			"COU_KFZ": "TON",
			"COU_ISO3166_3": "TON",
			"COU_VORWAHL": "+676",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "TO"
		},
		{
			"COU_ID": 591,
			"COU_NAME": "Trinidad und Tobago",
			"COU_KFZ": "TT",
			"COU_ISO3166_3": "TTO",
			"COU_VORWAHL": "+1809",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "TT"
		},
		{
			"COU_ID": 594,
			"COU_NAME": "Tschad",
			"COU_KFZ": "TD",
			"COU_ISO3166_3": "TCD",
			"COU_VORWAHL": "+235",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "TD"
		},
		{
			"COU_ID": 597,
			"COU_NAME": "Tschechische Republik",
			"COU_KFZ": "CZ",
			"COU_ISO3166_3": "CZE",
			"COU_VORWAHL": "+420",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "CZ"
		},
		{
			"COU_ID": 600,
			"COU_NAME": "Tunesien",
			"COU_KFZ": "TN",
			"COU_ISO3166_3": "TUN",
			"COU_VORWAHL": "+216",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "TN"
		},
		{
			"COU_ID": 603,
			"COU_NAME": "Türkei",
			"COU_KFZ": "TR",
			"COU_ISO3166_3": "TUR",
			"COU_VORWAHL": "+90",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "TR"
		},
		{
			"COU_ID": 606,
			"COU_NAME": "Turkmenistan",
			"COU_KFZ": "TM",
			"COU_ISO3166_3": "TKM",
			"COU_VORWAHL": "+993",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "TM"
		},
		{
			"COU_ID": 609,
			"COU_NAME": "Tuvalu",
			"COU_KFZ": "TUV",
			"COU_ISO3166_3": "TUV",
			"COU_VORWAHL": "+688",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "TV"
		},
		{
			"COU_ID": 612,
			"COU_NAME": "Uganda",
			"COU_KFZ": "EAU",
			"COU_ISO3166_3": "UGA",
			"COU_VORWAHL": "+256",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "UG"
		},
		{
			"COU_ID": 615,
			"COU_NAME": "Ukraine",
			"COU_KFZ": "UA",
			"COU_ISO3166_3": "UKR",
			"COU_VORWAHL": "+380",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "UA"
		},
		{
			"COU_ID": 618,
			"COU_NAME": "Ungarn",
			"COU_KFZ": "H",
			"COU_ISO3166_3": "HUN",
			"COU_VORWAHL": "+36",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "HU"
		},
		{
			"COU_ID": 621,
			"COU_NAME": "Uruguay",
			"COU_KFZ": "ROU",
			"COU_ISO3166_3": "URY",
			"COU_VORWAHL": "+598",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "UY"
		},
		{
			"COU_ID": 624,
			"COU_NAME": "Usbekistan",
			"COU_KFZ": "UZ",
			"COU_ISO3166_3": "UZB",
			"COU_VORWAHL": "+998",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "UZ"
		},
		{
			"COU_ID": 627,
			"COU_NAME": "Vanuatu",
			"COU_KFZ": "VAN",
			"COU_ISO3166_3": "VUT",
			"COU_VORWAHL": "+678",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "VU"
		},
		{
			"COU_ID": 630,
			"COU_NAME": "Vatikanstadt",
			"COU_KFZ": "V",
			"COU_ISO3166_3": "VAT",
			"COU_VORWAHL": "+396",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "VA"
		},
		{
			"COU_ID": 633,
			"COU_NAME": "Venezuela",
			"COU_KFZ": "YV",
			"COU_ISO3166_3": "VEN",
			"COU_VORWAHL": "+58",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "VE"
		},
		{
			"COU_ID": 636,
			"COU_NAME": "Vereinigte Arab. Emirate",
			"COU_KFZ": "UAE",
			"COU_ISO3166_3": "ARE",
			"COU_VORWAHL": "+971",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "AE"
		},
		{
			"COU_ID": 639,
			"COU_NAME": "Vereinigte Staaten von Amerika",
			"COU_KFZ": "USA",
			"COU_ISO3166_3": "USA",
			"COU_VORWAHL": "+1",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "US"
		},
		{
			"COU_ID": 642,
			"COU_NAME": "Vietnam",
			"COU_KFZ": "VN",
			"COU_ISO3166_3": "VNM",
			"COU_VORWAHL": "+84",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "VN"
		},
		{
			"COU_ID": 645,
			"COU_NAME": "Weihnachtsinsel",
			"COU_KFZ": null,
			"COU_ISO3166_3": null,
			"COU_VORWAHL": "+61",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "CX"
		},
		{
			"COU_ID": 648,
			"COU_NAME": "Zentralafrik. Republik",
			"COU_KFZ": "RCA",
			"COU_ISO3166_3": "CAF",
			"COU_VORWAHL": "+236",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "CF"
		},
		{
			"COU_ID": 651,
			"COU_NAME": "Zypern",
			"COU_KFZ": "CY",
			"COU_ISO3166_3": "CYP",
			"COU_VORWAHL": "+357",
			"COU_CONTINENT": "EU",
			"COU_ISO3166_2": "CY"
		},
		{
			"COU_ID": 654,
			"COU_NAME": "Südkorea",
			"COU_KFZ": "XX",
			"COU_ISO3166_3": "XX",
			"COU_VORWAHL": "+82",
			"COU_CONTINENT": "NOTEU",
			"COU_ISO3166_2": "KR"
		}
	]
`);

export default Countries;